import orderCustomForm from '@/api/order_custom_form'

export default ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    orderCustomForm.addOrderCustomFormField(result => {
      if (result.data.status === 'success') {
        commit('addOrderCustomFormField', result.data.data.detail)
      }
      resolve(result.data.data)
    }, param)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/actions/addOrderCustomFormField.js